import API from "@/models/API";

export default class Settings {
    constructor(item = {}) {
        this.primary_email = item.primary_email || ""
        this.secondary_email = item.secondary_email || ""
        this.export_csv_settings = item.export_csv_settings || {
            pon: false,
            email: false,
            address: false,
            name: false,
            postal_code: false,
            mobile: false,
            printed_catalog_code: false,
            order_date: false,
            city: false
        }
    }
    
    static getSettings = () =>
        API.get(
            `/suppliers/${localStorage.getItem("storeId")}/settings`
        );

    static updateSettings = (body) =>
        API.put(
            `/suppliers/${localStorage.getItem("storeId")}/settings`,
            body
        );
}
